import 'tslib';
import * as Long from 'long';
import '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import { Participant } from '../../core/model/Participant.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class ParticipantStore {
    static formatParticipantKey(val) {
        return `${val.conversationId}:${val.userId}`;
    }
    static toStore(p) {
        var _a, _b;
        const s = new ParticipantStore();
        s.userId = p.userId;
        s.secUid = p.secUid;
        s.sortOrder = (_a = p.sortOrder) === null || _a === void 0 ? void 0 : _a.toString();
        s.role = p.role;
        s.alias = p.alias;
        s.conversationId = p.conversationId;
        s.conversationType = p.conversationType;
        s.blocked = p.blocked;
        s.leftBlockTime = (_b = p.leftBlockTime) === null || _b === void 0 ? void 0 : _b.toString();
        s.readIndex = p.readIndex.toString();
        s.readOrder = p.readOrder.toString();
        s.minIndex = p.minIndex.toString();
        return s;
    }
    static fromStore(ctx, s) {
        var _a, _b, _c;
        const p = new Participant(ctx);
        p.userId = s.userId;
        p.secUid = s.secUid;
        p.sortOrder = s.sortOrder ? Long.fromValue(s.sortOrder) : undefined;
        p.role = s.role;
        p.alias = s.alias;
        p.conversationId = s.conversationId;
        p.conversationType = s.conversationType;
        p.blocked = s.blocked;
        p.leftBlockTime = s.leftBlockTime ? Long.fromValue(s.leftBlockTime) : undefined;
        p.readIndex = Long.fromValue((_a = s.readIndex) !== null && _a !== void 0 ? _a : 0);
        p.readOrder = Long.fromValue((_b = s.readOrder) !== null && _b !== void 0 ? _b : 0);
        p.minIndex = Long.fromValue((_c = s.minIndex) !== null && _c !== void 0 ? _c : 0);
        return p;
    }
}

export { ParticipantStore };
//# sourceMappingURL=ParticipantStore.js.map
